import axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { config } from "../../utils/conf";
import { requestHeaders } from "../../utils/http";
import useSession from "../Auth/useSession";

export default function useCreateRecipient(options = {}) {
  const { accessToken, customerId } = useSession();
  const cache = useQueryClient();

  const mutation = useMutation(
    async ({ userId, payload }) => {
      return axios.post(
        `${config.customerProfileApiUrl}/v1/customers/${customerId}/recipients`,
        payload,
        {
          headers: {
            ...requestHeaders(accessToken),
            "Content-Type": "application/json",
          },
        },
      );
    },
    {
      onSuccess: () => {
        cache.invalidateQueries("notification-recipients");
      },
      ...options,
    },
  );

  return {
    createNotification: mutation.mutateAsync,
    createNotificationStatus: mutation,
  };
}
